import { Stack, Modal, Typography, Button, Box, Chip } from "@mui/material";
import React from "react";
import warning_icon from "../../../assets/images/Icons/icAlert.svg";
import CustomProductionDateSelector from "./CustomProductionDateSelector";
import moment from "moment";
import { Loader } from "../../../shared";

const style = {
  position: "absolute",
  top: "52%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxHeight: "652px",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  borderRadius: "23px",
  outline: "none",
};

export const DeleteAlertDialog = (props) => {
  const {
    open,
    isDeleteScheduledDatesDialogOpen,
    resetDeleteInfo,
    handleDeleteScheduledDatesDialog,
    onSubmit,
    templateDetails,
    templateProductionDaysDetails,
    dropdownListQuery,
    globalData,
    isScheduledOrDelete,
    confirmDelete,
    allDates,
    allProductionDates,
    selectedProductionDates,
    setSelectedProductionDates,
    unselectedProductionDates,
    setUnselectedProductionDates,
    templateProductionDaysList,
  } = props;

  const isTemplateIn7DayChart = React.useMemo(() => {
    if (!allProductionDates?.length) return false;

    const chartDatesSet = new Set(allProductionDates);

    // 1. Check custom/added dates
    const byCustomDates = allDates?.some((d) => chartDatesSet.has(d));

    // 2. Check start to end range
    let byRange = false;

    if (templateProductionDaysDetails?.data?.[0]?.start_date) {
      const start = moment(templateProductionDaysDetails.data[0].start_date);
      const end = templateProductionDaysDetails.data[0].end_date
        ? moment(templateProductionDaysDetails.data[0].end_date)
        : moment().add(365, "days"); // open-ended recurring

      byRange = allProductionDates.some((d) =>
        moment(d).isBetween(start, end, "day", "[]"),
      );
    }

    return byCustomDates || byRange;
  }, [allProductionDates, allDates, templateProductionDaysDetails]);

  // const endDate =
  //   templateProductionDaysDetails?.data &&
  //   templateProductionDaysDetails?.data[0]?.end_date;
  // const toDay = moment().format("YYYY-MM-DD");
  // const isPastDate =
  //   (endDate && moment(endDate).isSameOrAfter(toDay, "day")) || !endDate;
  const ListofDropdown = dropdownListQuery?.data?.drop_down_list; //day week month

  const WeekOfMonth = dropdownListQuery?.data?.Week_Number_List; //first second...

  const MonthDropdown = dropdownListQuery?.data?.Month_List; //jan feb mar

  const WeekDays = dropdownListQuery?.data?.week_values; // sun mon tue

  const dateRangeColumns = (data) => {
    const val = data ? data : [];
    const dayValue = ListofDropdown?.find(
      (i) => i.value === val[0]?.drop_down_list,
    );
    if (val[0]?.sheduled_types === 7) {
      const selectedDay = globalData?.week_values?.filter((day) =>
        val[0]?.date?.includes(day?.value),
      );

      const weekOfMonth = WeekOfMonth?.find(
        (i) => i.value === val[0]?.dayofweek,
      );

      const monthValues = MonthDropdown?.find((i) => i.value === val[0]?.month);
      return (
        <Stack direction="row" gap="12px" alignItems="center">
          <Typography> Every </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {val[0]?.period}
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            Year
          </Typography>

          <Typography variant="subtitle2" fontWeight={400} color="text.primary">
            on the
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {weekOfMonth?.label}
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {selectedDay?.map((day) => day?.label)}
          </Typography>
          <Typography variant="subtitle2" fontWeight={400} color="text.primary">
            of
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {monthValues?.label}
          </Typography>
        </Stack>
      );
    }
    if (val[0]?.custom_date === 0 && val[0]?.drop_down_list === 1) {
      return (
        <Stack direction="row" gap="12px" alignItems="center">
          <Typography> Every </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {val[0]?.period}
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {dayValue?.label}
          </Typography>
        </Stack>
      );
    } else if (val[0]?.custom_date === 0 && val[0]?.drop_down_list === 2) {
      const selectedDays = globalData?.week_values?.filter((day) =>
        val[0]?.date.includes(day?.value),
      );

      return (
        <Stack direction="row" gap="12px" alignItems="center">
          <Typography> Every </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {val[0]?.period}
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {dayValue?.label}
          </Typography>
          <Typography variant="subtitle2" fontWeight={400} color="text.primary">
            on
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {selectedDays?.map((day) => day?.label).join(", ")}
          </Typography>
        </Stack>
      );
    } else if (
      val[0]?.custom_date === 0 &&
      val[0]?.drop_down_list === 3 &&
      val[0]?.sheduled_types === 4
    ) {
      const dayValue = ListofDropdown?.find(
        (i) => i.value === val[0]?.drop_down_list,
      );
      return (
        <Stack direction="row" gap="12px" alignItems="center">
          <Typography> Every </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {val[0]?.period}
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {dayValue?.label}
          </Typography>
          <Typography variant="subtitle2" fontWeight={400} color="text.primary">
            on day
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {val[0]?.day}
          </Typography>
        </Stack>
      );
    } else if (
      val[0]?.custom_date === 0 &&
      val[0]?.drop_down_list === 3 &&
      val[0]?.sheduled_types === 5
    ) {
      const weekValue = WeekOfMonth?.find(
        (i) => i.value === val[0]?.weekofmonth,
      );
      const dayValue = ListofDropdown?.find(
        (i) => i.value === val[0]?.drop_down_list,
      );
      const weekDaysValue = WeekDays?.find(
        (i) => i.value === val[0]?.dayofweek,
      );
      return (
        <Stack direction="row" gap="12px" alignItems="center">
          <Typography> Every </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {val[0]?.period}
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {dayValue?.label}
          </Typography>
          <Typography variant="subtitle2" fontWeight={400} color="text.primary">
            on the
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {weekValue?.label}
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {weekDaysValue?.label}
          </Typography>
        </Stack>
      );
    } else if (
      val[0]?.custom_date === 0 &&
      val[0]?.drop_down_list === 4 &&
      val[0]?.sheduled_types === 6
    ) {
      const dayValue = ListofDropdown?.find(
        (i) => i.value === val[0]?.drop_down_list,
      );
      const monthValue = MonthDropdown?.find((i) => i.value === val[0]?.month);
      return (
        <Stack direction="row" gap="12px" alignItems="center">
          <Typography> Every </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {val[0]?.period}
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {dayValue?.label}
          </Typography>

          <Typography variant="subtitle2" fontWeight={400} color="text.primary">
            on
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {monthValue?.label}
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {val[0]?.day}
          </Typography>
        </Stack>
      );
    } else if (
      val[0]?.custom_date === 0 &&
      val[0]?.drop_down_list === 4 &&
      val[0]?.sheduled_types === 7
    ) {
      const dayValue = ListofDropdown?.find(
        (i) => i.value === val[0]?.drop_down_list,
      );
      const weekOfMonth = WeekOfMonth?.find(
        (i) => i.value === val[0]?.dayofweek,
      );
      const weekDays = WeekDays?.find((i) => i.value === val[0]?.date);

      const monthValues = MonthDropdown?.find((i) => i.value === val[0]?.month);
      return (
        <Stack direction="row" gap="12px" alignItems="center">
          <Typography> Every </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {val[0]?.period}
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {dayValue?.label}
          </Typography>

          <Typography variant="subtitle2" fontWeight={400} color="text.primary">
            on the
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {weekOfMonth?.label}
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {weekDays?.label}
          </Typography>
          <Typography variant="subtitle2" fontWeight={400} color="text.primary">
            of
          </Typography>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            {monthValues?.label}
          </Typography>
        </Stack>
      );
    }
  };
  const isProductionDateLength = allProductionDates?.length > 0;
  return (
    <Modal open={isScheduledOrDelete ? isDeleteScheduledDatesDialogOpen : open}>
      <Box
        sx={{
          ...style,
          display: "flex",
          flexDirection: "column",
          width: isScheduledOrDelete ? "766px" : "596px",
        }}
      >
        {/* Top Content */}
        <Box sx={{ flexGrow: 1 }}>
          <Stack
            direction="row"
            gap="16px"
            alignItems="center"
            lineHeight="34.2px"
            marginBottom={3}
          >
            <Box
              sx={{
                width: "30px",
                height: "30px",
                borderRadius: "100%",
                backgroundColor: "#F044381F",
              }}
            >
              <img
                src={warning_icon}
                style={{ padding: "6px" }}
                alt="warning icon"
              />
            </Box>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "25px",
                lineHeight: "24.2px",
              }}
            >
              {isScheduledOrDelete
                ? "Set Template to Inactive?"
                : "Delete Template?"}
            </Typography>
          </Stack>
        </Box>

        {templateProductionDaysList?.isFetching ? (
          <Stack justifyContent="center" height="200px" alignItems="center">
            <Loader />
          </Stack>
        ) : (
          <>
            {!isScheduledOrDelete ? (
              isTemplateIn7DayChart ? (
                <Typography fontWeight={400} fontSize="16px" width={"100%"}>
                  {/* Please note that this template is associated with future
                  production charts
                  <div>
                    Would you still like to set this template to Delete?
                  </div> */}
                  This template is linked to generated production charts for the
                  following dates. Should we proceed with deleting this template
                  and the associated charts for the selected dates?
                </Typography>
              ) : (
                <Typography fontWeight={400} fontSize="16px" width={"100%"}>
                  {/* Should we proceed with setting this template to{" "}
                  <strong>DELETE</strong>? */}
                  Please note that this template is associated with future
                  production charts. Would you still like to delete this
                  template?
                </Typography>
              )
            ) : isTemplateIn7DayChart ? (
              <Typography fontWeight={400} fontSize="16px" width={"100%"}>
                This template is linked to generated production charts for the
                following dates. Should we proceed with setting this template to{" "}
                <strong>INACTIVE</strong> and deleting the associated charts for
                the selected dates?
              </Typography>
            ) : (
              <Typography fontWeight={400} fontSize="16px" width={"100%"}>
                {/* Should we proceed with setting this template to{" "}
                <strong>Inactive</strong>? */}
                Please note that this template is associated with future
                production charts. Would you still like to set this template to
                <strong> Inactive</strong>?
              </Typography>
            )}
            {isProductionDateLength && (
              <CustomProductionDateSelector
                allProductionDates={allProductionDates}
                selectedProductionDates={selectedProductionDates}
                setSelectedProductionDates={setSelectedProductionDates}
                unselectedProductionDates={unselectedProductionDates}
                setUnselectedProductionDates={setUnselectedProductionDates}
              />
            )}
            {templateProductionDaysDetails?.data && (
              <>
                {(templateProductionDaysDetails?.data[0]?.start_date ||
                  templateProductionDaysDetails?.data[0]?.end_date ||
                  templateProductionDaysDetails?.data[0]?.length > 0) && (
                  <Typography
                    fontWeight={600}
                    fontSize="16px"
                    lineHeight="24.2px"
                    mt="8px"
                  >
                    Date Settings:
                  </Typography>
                )}
                <Stack direction="row" gap={1}>
                  {templateProductionDaysDetails?.data[0]?.start_date && (
                    <>
                      <Typography fontWeight={500} fontSize="16px" mt={1}>
                        Start Date:
                      </Typography>
                      <Typography fontWeight={400} fontSize="16px" mt={1}>
                        {templateProductionDaysDetails?.data &&
                          moment(
                            templateProductionDaysDetails?.data[0]?.start_date,
                          ).format("DD-MM-YYYY")}
                      </Typography>
                    </>
                  )}
                  {templateProductionDaysDetails?.data[0]?.end_date && (
                    <>
                      <Typography
                        fontWeight={500}
                        fontSize="16px"
                        mt={1}
                        ml={2}
                      >
                        End Date:
                      </Typography>
                      <Typography fontWeight={400} fontSize="16px" mt={1}>
                        {templateProductionDaysDetails?.data &&
                          moment(
                            templateProductionDaysDetails?.data[0]?.end_date,
                          ).format("DD-MM-YYYY")}
                      </Typography>
                    </>
                  )}
                </Stack>
                {templateProductionDaysDetails?.data?.length > 0 && (
                  <Stack direction="row" gap={1} mt={1}>
                    <Typography fontWeight={500} fontSize="16px">
                      Repeat:{" "}
                    </Typography>
                    {dateRangeColumns(templateProductionDaysDetails?.data)}
                  </Stack>
                )}
              </>
            )}

            {/* Custom Dates Section */}
            {allDates?.length > 0 && (
              <Stack mt={1}>
                <Typography fontWeight={600}>Custom Dates</Typography>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    flexWrap: "wrap",
                    mb: 2,
                    mt: 1,
                  }}
                >
                  {allDates?.slice(0, 4)?.map((date, index) => (
                    <Chip
                      key={index}
                      variant="outlined"
                      color="gray"
                      size="small"
                      label={
                        date
                          ? moment(date, "YYYY-MM-DD").format("DD MMM YYYY")
                          : null
                      }
                    />
                  ))}

                  {allDates?.length > 4 && (
                    <Typography
                      fontWeight={600}
                      fontSize="14px"
                      color="#485364"
                    >
                      +{allDates?.length - 4} more
                    </Typography>
                  )}
                </Box>
              </Stack>
            )}
          </>
        )}
        {/* Sticky Footer */}
        <Box
          sx={{
            position: "sticky",
            top: "100%",
            backgroundColor: "background.paper",
            alignSelf: "end",
          }}
        >
          <Stack direction="row" gap={1} justifyContent="flex-start">
            <Button
              variant="outlined"
              color="gray2"
              onClick={
                isScheduledOrDelete
                  ? () =>
                      handleDeleteScheduledDatesDialog(
                        false,
                        templateDetails?.data,
                      )
                  : resetDeleteInfo
              }
            >
              Close
            </Button>
            <Button
              onClick={isScheduledOrDelete ? onSubmit : () => confirmDelete()}
              variant="contained"
              color={isScheduledOrDelete ? "primary" : "error"}
            >
              {isScheduledOrDelete ? "Deactivate" : "Delete"}
            </Button>
          </Stack>
        </Box>
      </Box>
    </Modal>
  );
};
